import { ActionFunctionMap } from 'xstate'
import { IContext, IMachineEvents } from '../../types'

const actions: ActionFunctionMap<IContext, IMachineEvents> = {}

export default actions
